export default __webpack_public_path__ + "static/media/Connecticut6Closed.61631dd3.jpg";